import { render, staticRenderFns } from "./imports.vue?vue&type=template&id=5b8842c7&scoped=true&"
import script from "./imports.vue?vue&type=script&lang=js&"
export * from "./imports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8842c7",
  null
  
)

export default component.exports